export default {
  paused: 'Online betalingen zijn gepauzeerd vanwege KYC-verificatieproblemen.',
  deadline_warning: 'KYC-verificatie is vereist, anders worden online betalingen gepauzeerd op {{date}}.',
  complete_verification: 'Verificatie voltooien',
  partner: {
    action_needed: 'Uw betalingsprovider heeft nog iets nodig voordat dit restaurant online betalingen kan ontvangen.',
    hosted_incomplete: 'U bent nog niet klaar met het instellen van online betalingen bij uw betalingsprovider.',
    link_expired: 'Uw link om online betalingen in te stellen is verlopen. Vraag een nieuwe aan en ga verder.',
    open_error: 'De betalingsprovider kon niet worden bereikt. Probeer het over enkele minuten opnieuw.',
    hosted_not_started: 'Online betalingen zijn nog niet ingesteld bij je betalingsprovider.',
    business_details_missing: 'Voeg je bedrijfsgegevens toe om online betalingen te kunnen ontvangen.',
    continue: 'Doorgaan',
  },
};
